import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { NgbCalendar, NgbDate,  NgbDateStruct, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import moment from "moment";
import dateFormats from '../../const/date-formats';

@Component({
  selector: 'date-range',
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.scss'],
  imports: [FormsModule, TranslateModule, NgbModule]
})
export class DateRangeComponent implements OnInit {

  @Input() from: Date;
  @Output() fromChange = new EventEmitter<Date>();
  @Input() to: Date;
  @Output() toChange = new EventEmitter<Date>();
  @Output() change = new EventEmitter();

  

  @ViewChild('datepicker', { static: false }) datepicker;

  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;

  constructor(private calendar: NgbCalendar) {
  }

  ngOnInit(): void {
    if (this.from)
      this.fromDate = new NgbDate(this.from.getFullYear(), this.from.getMonth() + 1, this.from.getDate())
    if (this.to)
      this.toDate = new NgbDate(this.to.getFullYear(), this.to.getMonth() + 1, this.to.getDate())
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
      this.datepicker.close()
    } else {
      this.toDate = null;
      this.fromDate = date;
    }

    //Emit changes
    if (this.fromDate)
      this.from = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day);
    else
      this.from = null
    this.fromChange.emit(this.from)

    if (this.toDate)
      this.to = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day);
    else
      this.to = null
    this.toChange.emit(this.to)

    this.change.emit()
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) &&
      date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) { return this.toDate && date.after(this.fromDate) && date.before(this.toDate); }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) ||
      this.isHovered(date);
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.parse(input);
    console.log(parsed)
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

  reset() {
    this.fromDate = null
    this.toDate = null
  }

  parse(value: string): NgbDateStruct {
    if (value) {
      value = value.trim();
      const tmp: any = moment(value, dateFormats.DATE)
      console.log(value)
      if (tmp && value.split(".").length == 3)
        return { year: tmp.year(), month: parseInt(tmp.month() + 1), day: tmp.date() }
    }
    return null;
  }

  format(date: NgbDateStruct): string {
    if (!date) return '';
    const mdt = moment([date.year, date.month - 1, date.day]);
    if (!mdt.isValid()) return '';
    return mdt.format(dateFormats.DATE);
  }
}
